import {FC} from 'react';
import './Toggles.less';
import {FormControlLabel, FormGroup, Switch} from "@mui/material";

export type ToggleProp = {
    label: string | any;
    enabled?: boolean;
    toggleClickFn?: Function;
    toggleFilterFn: Function;
}

export type TogglesProps = {
    toggles: ToggleProp[];
    onClick: Function,

    // Should we right-indent the toggles (leaving space for an icon)?
    indented?: boolean
}

const Toggles: FC<TogglesProps> = props => {

    const onClick = (toggle: ToggleProp) => {
        toggle.toggleClickFn?.(!toggle.enabled);
        props.onClick(toggle);
    };
    
    const indented = props.indented ? 'indented' : '';
    return <div className={`toggles ${indented}`}>
        <FormGroup row={true}>
            {props.toggles.map((toggle, index) =>
                <FormControlLabel key={toggle.label}
                                  control={<Switch checked={toggle.enabled ?? false}
                                                   onClick={() => onClick(toggle)}
                                                   size='small'
                                                   color='success'
                                  />}
                                  label={toggle.label}
                />
            )}
        </FormGroup>
    </div>;
}

export default Toggles;